export const sidebarWidth = "220px";
export const collapsedDesktopWidth = "70px";
export const placement = "left";
export const entityName = "sidebar-status";
